<template>
  <div class="cell large-5 xxlarge-3">
    <div class="card">
      <div class="grid-x card-header">
        <div class="cell auto">
          <h3 class="icon-heading small">
            <span class="icon">
              <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg>
            </span>
            Mine Tall
          </h3>
        </div>

        <!-- Date select dropdown -->
        <div class="cell shrink">
          <div class="select-container small has-popover" :class="{'popover-active': dateTypePopoverActive}" @click="toggleDateTypePopover()">
            <a class="button-select" href="javascript:;">
              <span class="title"><span>{{selectedDateType}}</span></span>
              <span class="glyph"><svg viewBox="0 0 6 12"><use xlink:href="/static/sprites.svg#glyph-input-select-tiny"></use></svg></span>
            </a>

            <span class="popover select-dropdown-popover align-x-right align-y-bottom large">
              <div class="custom-scrollbar">
                <ul>
                  <li v-for="item in dateTypeDropdown" :key="item.key" :class="{'active': item.key === selectedDateTypeId}">
                    <a href="javascript:;" @click="setDateType(item.key)"><span>{{item.val || item.key}}</span></a>
                  </li>
                </ul>
              </div>
            </span>
          </div>
        </div>
        <!-- Date select dropdown -->
      </div>

      <table v-if="loading" class="reporting dashboard skeleton-content">
        <tbody>
          <tr>
            <td class="sk-text sk-text-wide"></td>
            <td class="align-right sk-text sk-text-medium"></td>
          </tr>
          <tr>
            <td class="sk-text sk-text-wide"></td>
            <td class="align-right sk-text sk-text-medium"></td>
          </tr>
          <tr>
            <td class="sk-text sk-text-wide"></td>
            <td class="align-right sk-text sk-text-medium"></td>
          </tr>
          <tr>
            <td class="sk-text sk-text-wide"></td>
            <td class="align-right sk-text sk-text-medium"></td>
          </tr>
        </tbody>
      </table>
      <table v-else class="reporting dashboard">
        <tbody>
          <tr>
            <td>
              <span class="title">
                <svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-contract"></use></svg>
                Kontrakter
              </span>
            </td>
            <td class="align-right">
              <span class="large">{{ data.kontrakter | thousands }}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="title">
                <svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-object"></use></svg>
                Solgte objekter
              </span>
            </td>
            <td class="align-right">
              <span class="large">{{ data.objekter | thousands }}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="title">
                <svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-user-new"></use></svg>
                Vurdering lav
              </span>
            </td>
            <td class="align-right">
              <span class="large">{{ data.vurderinglav | thousands }}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="title">
                <svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-calculator"></use></svg>
                Tilslag
              </span>
            </td>
            <td class="align-right">
              <span class="large">{{ data.salgspris | thousands }}</span>
            </td>
          </tr>
          <tr v-if="this.$store.getters.getUser.Ekspert">
            <td>
              <span class="title">
                <svg width="28px" height="28px" viewBox="-2 -3 22 22"><use xlink:href="/static/sprites.svg#bi-1-circle"></use></svg>
                Objekter, solgt 1. forsøk
              </span>
            </td>
            <td class="align-right">
              <span class="large">{{ formatPercentage(data.firstSellingObject, data.totalObjects) | thousandsFloat }} %</span>
            </td>
          </tr>
          <tr v-if="this.$store.getters.getUser.Ekspert">
            <td>
              <span class="title">
                <svg width="28px" height="28px" viewBox="-2 -3 22 22"><use xlink:href="/static/sprites.svg#bi-three-dots"></use></svg>
                Objekter, Solgt, Totalt
              </span>
            </td>
            <td class="align-right">
              <span class="large">{{ formatPercentage(data.totalObjectsSold, data.totalObjects) | thousandsFloat }} %</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import StatistikkService from '@/services/StatistikkService'

export default {
  name: 'WidgetMineTall',
  props: {
    brukerList: {
      type: Array,
      required: false,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      loading: false,
      selectedBrukerId: null,
      dateTypePopoverActive: false,
      selectedDateTypeId: null,
      dateTypeDropdown: [
        { key: '30-days', val: 'Siste 30 dager' },
        { key: '6-months', val: 'Siste halvår' },
        { key: '1-year', val: 'Siste år' }
      ],
      data: {
        kontrakter: 0,
        objekter: 0,
        vurderinglav: 0,
        salgspris: 0,
        firstSellingObject: 0,
        totalObjectsSold: 0,
        totalObjects: 0
      }
    }
  },
  watch: {
    selectedDateTypeId: function () {
      this.reloadData()
    }
  },
  created () {
    const vm = this

    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.dateTypePopoverActive = false
      }
    })

    // Get user and its avdeling
    this.selectedBrukerId = this.$store.getters.getUser.Brukernavn
    this.selectedDateTypeId = localStorage.dbw_mine_tall_dt || '30-days'
  },
  computed: {
    selectedDateType: function () {
      const found = this.dateTypeDropdown.find(x => x.key === this.selectedDateTypeId)

      return found ? found.val : ''
    }
  },
  methods: {
    reloadData: function () {
      this.loading = true

      const today = new Date()
      const query = {
        brukernavn: this.selectedBrukerId,
        avdelingsid: null,
        from: null,
        till: moment().format('YYYY-MM-DD')
      }

      switch (this.selectedDateTypeId) {
        case '1-year':
          query.from = moment(today).subtract(1, 'year').format('YYYY-MM-DD')
          break
        case '6-months':
          query.from = moment(today).subtract(6, 'months').format('YYYY-MM-DD')
          break
        case '30-days':
        default:
          query.from = moment(today).subtract(30, 'days').format('YYYY-MM-DD')
          break
      }

      StatistikkService.loadExpertsJson(
        query.from,
        query.till,
        query.avdelingsid,
        query.brukernavn
      )
        .then(response => {
          let found = {}

          if (response.data && response.data.length > 0) {
            found = response.data.find(i => i.Brukernavn === query.brukernavn) || {}
          }

          Object.keys(this.data).forEach(key => {
            this.data[key] = found.hasOwnProperty(key) ? found[key] : 0
          })
        })
        .catch(error => {
          console.log('Error')
          console.log(error)

          // Reset data
          Object.keys(this.data).forEach(key => {
            this.data[key] = 0
          })
        })
        .then(() => {
          this.loading = false
        })
    },
    setDateType: function (itemId) {
      this.selectedDateTypeId = itemId || null

      if (this.selectedDateTypeId) {
        localStorage.dbw_mine_tall_dt = this.selectedDateTypeId
      } else {
        localStorage.removeItem('dbw_mine_tall_dt')
      }
    },
    toggleDateTypePopover: function () {
      this.dateTypePopoverActive = !this.dateTypePopoverActive
    },
    formatPercentage: function (dividend, divisor) {
      if (isNaN(dividend) || isNaN(divisor)) {
        return 0
      }
      return ((dividend * 100) / divisor)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard/WidgetMineTall.vue